export default "__VITE_ASSET__BjCNyp8q__"